import { useCallback, useRef } from "react";
import Downshift from "downshift";
var stateChangeTypes = Downshift.stateChangeTypes;
var KEYBOARD_NAVIGATION_TYPES = [stateChangeTypes.keyDownArrowDown, stateChangeTypes.keyDownArrowUp, stateChangeTypes.keyDownHome, stateChangeTypes.keyDownEnd].filter(Boolean);
export function useKeyboardMenuScroll() {
  var allowScrollRef = useRef(false);
  var trackStateChange = useCallback(function (changes) {
    if (changes && Object.prototype.hasOwnProperty.call(changes, "highlightedIndex")) {
      allowScrollRef.current = KEYBOARD_NAVIGATION_TYPES.includes(changes.type);
    }
    return changes;
  }, []);
  var scrollIntoView = useCallback(function (node, menuNode) {
    if (!node || !menuNode) return;
    if (!allowScrollRef.current) return;
    allowScrollRef.current = false;
    var item = node.getBoundingClientRect();
    var menu = menuNode.getBoundingClientRect();
    if (item.top < menu.top) {
      menuNode.scrollTop -= menu.top - item.top;
    } else if (item.bottom > menu.bottom) {
      menuNode.scrollTop += item.bottom - menu.bottom;
    }
  }, []);
  return {
    trackStateChange: trackStateChange,
    scrollIntoView: scrollIntoView
  };
}
//# sourceMappingURL=downshiftScroll.js.map